import type { IconData } from '@stacksjs/iconify-core'

export const searchVisual: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M13 3s-3.086 0-6.356.193a3.66 3.66 0 0 0-3.45 3.45C3 9.913 3 13 3 13M35 3s3.086 0 6.356.193a3.66 3.66 0 0 1 3.45 3.45C45 9.913 45 13 45 13M35 45s3.086 0 6.356-.193a3.66 3.66 0 0 0 3.45-3.45C45 38.087 45 35 45 35M13 45s-3.086 0-6.356-.193a3.66 3.66 0 0 1-3.45-3.45C3 38.087 3 35 3 35m30.17-6.345A12.94 12.94 0 0 0 35 22c0-7.18-5.82-13-13-13S9 14.82 9 22s5.82 13 13 13a12.94 12.94 0 0 0 6.737-1.88l.055.066c1.1 1.328 2.184 2.635 3.397 3.923c1.086 1.154 2.724 1.301 3.876.213a33 33 0 0 0 1.325-1.325c1.088-1.151.94-2.79-.213-3.876c-1.289-1.213-2.596-2.296-3.923-3.396z\"/><path d=\"M16 22a6 6 0 1 0 12 0a6 6 0 1 0-12 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default searchVisual
